import React from "react";
import { Table, Image, Badge } from "react-bootstrap";

const TableRow = ({ data, sr, updateEntry, deleteEntry }) => {
  return (
    <tr className="align-middle">
      <td className="text-center" style={{ minWidth: "180px" }}>
        {data.cover_img ? (
          <Image
            src={data.cover_img}
            alt={data.title}
            thumbnail
            style={{ width: 60, height: 60, objectFit: "cover" }}
          />
        ) : (
          <span className="text-muted">No Image</span>
        )}
      </td>

      <td className="fw-semibold text-center" style={{ minWidth: "180px" }}>
        {data.title}
      </td>

      <td className="text-center text-muted" style={{ minWidth: "160px" }}>
        <small>{data.slug}</small>
      </td>

      <td style={{ maxWidth: "300px" }}>
        <div className="text-truncate" style={{ maxWidth: 280 }}>
          {data.summary}
        </div>
      </td>

      <td className="text-center" style={{ minWidth: "120px" }}>
        {data.status === "published" ? (
          <Badge bg="success">Published</Badge>
        ) : (
          <Badge bg="warning text-dark">Draft</Badge>
        )}
      </td>

      <td className="fw-semibold text-center">{data.order}</td>

      <td className="text-center" style={{ minWidth: "120px" }}>
        {/* <span style={{ cursor: "pointer" }} onClick={() => updateEntry(data)}>
          <i className="bi bi-pen text-warning me-2"></i>
        </span> */}
        <span style={{ cursor: "pointer" }} onClick={() => deleteEntry(data)}>
          <i className="bi bi-trash text-danger"></i>
        </span>
      </td>
    </tr>
  );
};

const BlogsTable = ({ list = [], updateEntry, deleteEntry }) => {
  let i = 1;
  return (
    <Table responsive hover bordered style={{ fontSize: "14px" }}>
      <thead>
        <tr>
          <th style={{ width: "80px" }}>Cover</th>
          <th>Title</th>
          <th>Slug</th>
          <th>Summary</th>
          <th style={{ width: "120px" }}>Status</th>
          <th style={{ width: "100px" }}>Order</th>
          <th style={{ width: "120px" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {list?.map((entry, index) => (
          <TableRow
            data={entry}
            key={index}
            sr={i++}
            updateEntry={updateEntry}
            deleteEntry={deleteEntry}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default BlogsTable;
